@if (highlight) {
    <div class="highlight-wrapper">
        <span>
            {{ highlight.headline }}
        </span>
        <sew-markdown ws [markdown]="highlight.text | replaceLinebreak"></sew-markdown>
    </div>
}
